"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _AddOrEditOrgDialog = _interopRequireDefault(require("./components/org/AddOrEditOrgDialog"));
var _AuthOrgDialog = _interopRequireDefault(require("./components/org/AuthOrgDialog"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _org = require("@/api/auth/org");
var _orgGroup = require("@/api/auth/orgGroup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'orgIndex',
  components: {
    AddOrEditOrgDialog: _AddOrEditOrgDialog.default,
    AuthOrgDialog: _AuthOrgDialog.default,
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    typeFilter: function typeFilter(key) {
      return typesKeyValue[key];
    }
  },
  computed: {
    hasOrgCombobox: function hasOrgCombobox() {
      return sessionStorage.getItem('userBtns').includes('sysOrg:combobox');
    }
  },
  data: function data() {
    return {
      options: [],
      //组织组类型查询
      tableKey: 0,
      list: null,
      buttonSelectedList: '',
      total: null,
      listLoading: true,
      listQuery: {
        orgGroupCode: null,
        page: 1,
        limit: 20,
        keywords: null
      },
      addOrEditData: {
        //添加 或者 编辑 dialog 数据
        status: 'create',
        //[create ,update]
        visible: false,
        orgId: null //选中的组织
      },
      authData: {
        //授权弹框数据
        orgId: null,
        //授权 组织
        orgName: null,
        //组织名称
        visible: false //弹框 显示标识
      }
    };
  },
  created: function created() {
    this.getList();
    this.getOrgGroupList();
  },
  methods: {
    getOrgGroupList: function getOrgGroupList() {
      var _this = this;
      (0, _orgGroup.queryOrgGroupALL)().then(function (response) {
        if (response.data) {
          _this.options = response.data.records;
        }
      });
    },
    refreshData: function refreshData() {
      this.addOrEditData.status = 'create';
      this.addOrEditData.visible = false;
      this.addOrEditData.orgId = null; //选中的组织
      this.handleFilter();
    },
    getList: function getList() {
      var _this2 = this;
      //查询
      this.listLoading = true;
      (0, _org.queryOrgPage)(this.listQuery).then(function (response) {
        if (response) {
          _this2.list = response.records;
          _this2.total = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    handleCreate: function handleCreate() {
      //触发添加dialog
      //查询组织 - 角色
      this.addOrEditData.status = 'create';
      this.addOrEditData.visible = true;
      this.addOrEditData.orgId = null;
    },
    handleUpdate: function handleUpdate(row) {
      //触发更新Dialog和创建的dialog共用一个dialog
      this.addOrEditData.status = 'update';
      this.addOrEditData.visible = true;
      this.addOrEditData.orgId = row.orgId;
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      //删除
      this.$confirm(this.$t("prompts.wantDelRecord"), this.$t("prompts.prompts"), {
        confirmButtonText: this.$t("buttons.Confirm"),
        cancelButtonText: this.$t("buttons.Cancel"),
        type: "warning"
      }).then(function () {
        (0, _org.deleteOrg)(row.orgId).then(function () {
          _this3.$notify({
            title: _this3.$t("prompts.success"),
            message: _this3.$t("prompts.DeletedSuc"),
            type: 'success',
            duration: 3000
          });
          var index = _this3.list.indexOf(row);
          _this3.list.splice(index, 1); //数值删除
        });
      });
    },
    handleOrgRes: function handleOrgRes(row) {
      //触发授权dialog
      this.authData.orgId = row.orgId;
      this.authData.orgName = row.name;
      this.authData.visible = true;
    }
  }
};